import { bindHTTP } from '@frontend/schema';
import { ReviewsInvitationService } from '@weave/schema-gen-ts/dist/schemas/reviews/invitation/v1/service.pb';
export const SchemaReviewsInvitationService = bindHTTP(ReviewsInvitationService);
